// frontend/src/pages/PaymentHistory/components/SummaryCard.tsx
// One summary tile: uppercase label, large value, small sub-text.
// Pure presentation; reusable from any dashboard or report.

import React from "react";
import { T, MONO } from "../styles";

interface SummaryCardProps {
  label: string;
  value: string;
  sub: string;
  /** When true, uses the body font at a smaller size instead of the big MONO figure */
  smallValue?: boolean;
}

export default function SummaryCard({
  label,
  value,
  sub,
  smallValue = false,
}: SummaryCardProps): React.ReactElement {
  return (
    <div
      style={{
        background: T.cardAlt,
        border: "1px solid " + T.lineDark,
        borderRadius: 10,
        padding: "16px 18px",
      }}
    >
      <div
        style={{
          fontSize: 11.5,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          color: T.muted,
          marginBottom: 8,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: smallValue ? 15 : 22,
          fontWeight: 700,
          fontFamily: smallValue ? "inherit" : MONO,
          color: T.ink,
          letterSpacing: smallValue ? 0 : "-0.5px",
        }}
      >
        {value}
      </div>
      <div
        style={{
          fontSize: 12,
          color: T.muted,
          marginTop: 4,
          fontWeight: 500,
        }}
      >
        {sub}
      </div>
    </div>
  );
}